"use strict";
exports.__esModule = true;
exports.chart_tooltip_flyoutStyle_stroke_Width = {
  "name": "--pf-chart-tooltip--flyoutStyle--stroke--Width",
  "value": 0,
  "var": "var(--pf-chart-tooltip--flyoutStyle--stroke--Width, 0)"
};
exports["default"] = exports.chart_tooltip_flyoutStyle_stroke_Width;